import { I18n } from 'react-redux-i18n';

export const getThTooltip = (key, tableName) => {
  if (key === 'stockePicks') {
    return I18n.t(`table.strategy.${tableName}StockPicks`);
  }
  return null;
};
